module.exports = __webpack_public_path__ + "img/Pag6.00449b08.png";